import React, { useState } from 'react';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';
import { liveDeployApis } from 'apis/common/deployApi';
import DefaultInput from 'components/input/DefaultInput';
import DeployModalText from 'components/etc/DeployModalText';
import TextCenterContainer from 'components/container/TextCenterContainer';
import DefaultButton from 'components/button/DefaultButton';
import DefaultForm from './DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import { useTranslation } from 'react-i18next';
/**
 * * 배포 모달
 */

interface IProps {
  kind: string;
  title: string;
  visible: boolean;
  fetchData: () => void;
  setVisible: (e: any) => void;
}
const DeployModal = ({
  visible,
  setVisible,
  fetchData,
  title,
  kind,
}: IProps) => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const { user_id } = cookies?.loginAdmin;
  const [reasonData, setReasonData] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [validation, setValidation] = useState<boolean>();

  /// 배포 사유 입력
  const handleInputChange = (e: { target: HTMLInputElement }) => {
    if (e.target.value === '') {
      setValidation(true);
    } else {
      setValidation(false);
    }
    setReasonData(e.target.value);
  };

  /// 배포하기
  const handleDeploy = async () => {
    // 유효성
    if (reasonData === '') {
      setValidation(true);
      return false;
    }

    const res = liveDeployApis.dataDeploy(user_id);
    if (!res) {
      return false;
    }
    fetchData();
    setVisible(false);
    setReasonData('');
  };
  const handleClose = () => {
    setVisible(false);
  };
  return (
    <DefaultModal
      title={`${title} ${t('multilang.deployModal.titleChild')}`}
      visible={visible}
      onCancel={handleClose}
      footer={
        <DefaultButton onClick={handleDeploy}>
          {t('multilang.deployModal.deploy')}
        </DefaultButton>
      }
    >
      <DefaultForm>
        <TextCenterContainer>
          <DeployModalText>
            <>
              <span>{title}</span>{' '}
              {t('multilang.deployModal.deployToTheLiveServer')}
            </>
          </DeployModalText>
          <DeployModalText>
            {t('multilang.deployModal.deployModalText')}
          </DeployModalText>
        </TextCenterContainer>
        <DefaultInput
          // title="배포 사유"
          name='reason'
          value={reasonData}
          onChange={handleInputChange}
          placeholder={t('multilang.deployModal.inputPlaceHolder')}
          maxLength={60}
        />
        <>
          {validation && (
            <WarnText>{t('multilang.deployModal.validationWarnText')}</WarnText>
          )}
        </>
      </DefaultForm>
    </DefaultModal>
  );
};

export default DeployModal;
const WarnText = styled.p`
  color: red;
  margin-left: 0.2rem;
  margin-top: 0.2rem;
`;
